// ** React Imports
import { useRef, useState } from 'react'

// ** Custom Components
import Wizard from '@components/wizard'

// ** Steps
import CompanyInfo from './steps-with-validation/CompanyInfo'
import PersonalInfo from './steps-with-validation/PersonalInfo'
import DSN from './steps-with-validation/DSN'
import Stuff from './steps-with-validation/Stuff'
import AddUsers from './steps-with-validation/AddUsers'
import { OnboardingProvider } from './OnboardingContext'
import { useTranslation } from 'react-i18next'

const Onboarding = () => {
  // ** Ref
  const ref = useRef(null)
  const { t } = useTranslation()

  // ** State
  const [stepper, setStepper] = useState(null)

  const steps = [
    {
      id: 'dsn',
      title: t('DSN-title'),
      subtitle: t('DSN-subtitle'),
      content: <DSN stepper={stepper} />
    },
    {
      id: 'company-info',
      title: t('company-title'),
      subtitle: t('company-subtitle'),
      content: <CompanyInfo stepper={stepper} />
    },
    {
      id: 'personal-info',
      title: t('personal-info-title'),
      subtitle: t('personal-info-subtitle'),
      content: <PersonalInfo stepper={stepper} />
    },
    {
      id: 'users',
      title: t('users-title'),
      subtitle: t('users-subtitle'),
      content: <AddUsers stepper={stepper} />
    },
    {
      id: 'documentation',
      title: t('welcome-title'),
      subtitle: t('welcome-subtitle'),
      content: <Stuff stepper={stepper} />
    }
  ]

  return (
    <div>
      <OnboardingProvider>
        <Wizard instance={el => setStepper(el)} ref={ref} steps={steps} />
      </OnboardingProvider>
    </div>
  )
}

export default Onboarding
